"use client";

import React from "react";
import "./Future_Ready.css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

const Future_Ready = () => {
  return (
    <section className="future_ready" id="future_ready">
      <div className="container">
        <div className="row align-items-center">

          {/* RIGHT IMAGE - TOP ON MOBILE */}
          <div className="col-lg-6 col-md-6 col-12 order-1 order-lg-2">
            <div className="future_ready_image">
              <img
                src="/assets/images/future_ready/university_img.webp"
                alt="Future Ready AI Native MBA"
              />
            </div>
          </div>

          {/* LEFT CONTENT - BELOW IMAGE ON MOBILE */}
          <div className="col-lg-6 col-md-6 col-12 order-2 order-lg-1">
            <div className="future_ready_content">
              <CommonHeading
                subTitle="Future-Ready"
                title="AI-Native MBA"
                description="Built for the AI era, India’s first AI-native corporate Online MBA goes beyond traditional business education. Alongside your degree, earn a Builder Score that validates your ability to build with AI and a Human Edge Index that measures the leadership, judgment, and critical thinking skills employers value most"
              />

              {/* STATS */}
              <div className="future_ready_stats">
                <div className="future_stat">
                  <h2>2 Years</h2>
                  <p>Online Program</p>
                </div>

                <div className="future_stat">
                  <h2>Live + Flexible</h2>
                  <p>Interactive Learning</p>
                </div>

                <div className="future_stat">
                  <h2>87 Credits</h2>
                  <p>Comprehensive Curriculum</p>
                </div>

                <div className="future_stat">
                  <h2>Adaptive Pace</h2>
                  <p>Up to 4 Years to Complete</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Future_Ready;